import React, { Component } from 'react';
import MapArrData from '../MapData/MapArrData';
import Countdown from './Countdown.jsx';
import QuestionContainer from './QuestionContainer.jsx';
import OptionsContainer from './OptionsContainer.jsx';
import ScoreCard from './ScoreCard/ScoreCard.jsx';
import StartBtn from './StartBtn.jsx';
import SetInterval from 'set-interval';

import Fire from '../Database/fire.jsx';

class QuizContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // mapSrc: MapArrData[Math.floor(Math.random() * MapArrData.length)][0],
      // TESTING
      // require('../MapData/images/si.svg')
      // PRODUCTION
      // require('../components/Landing/Assets/planet.svg')
      mapSrc: require('../components/Landing/Assets/planet.svg'),
      mapValue: 'India',
      optionsArr: [],
      score: 0,
      finalScore: 0,
      wrongCounter: 5,
      lastHighestScore: 0,
      sortedScoreData: [],
      timeRemaining: 60,
      gameFlag: 'Start Game',
      gameStatus: false,
      showHighScore: false,
    };
    this.generateQuestion = this.generateQuestion.bind(this);
    this.shuffle = this.shuffle.bind(this);
    this.timeCountdown = this.timeCountdown.bind(this);
    this.startQuiz = this.startQuiz.bind(this);
    this.scoreIncrement = this.scoreIncrement.bind(this);
    this.scoreDecrement = this.scoreDecrement.bind(this);
    this.gameOver = this.gameOver.bind(this);
    this.timer = this.timer.bind(this);
    this.showScoreCard = this.showScoreCard.bind(this);
  }
  // FUNCTIONS HERE

  async componentDidMount() {
    let scoreDataArray = [];
    // eslint-disable-next-line
    let tempDataSet = await Fire.collection('ranks')
      .get()
      .then((snapshot) => {
        snapshot.docs.forEach((doc) => {
          scoreDataArray.push(doc.data());
        });
      });

    let sortedScoreData = scoreDataArray.sort((a, b) => {
      return b.score - a.score;
    });
    // Getting the last score to check if New Score is to be Addded
    let lastHighestScore;

    // if the array length is more than 100
    if (sortedScoreData.length > 100) {
      lastHighestScore = sortedScoreData[99];
      // console.log(lastHighestScore);
    }

    this.setState({
      lastHighestScore: lastHighestScore,
      sortedScoreData: sortedScoreData,
    });
  }

  // START
  startQuiz() {
    if (!this.state.gameStatus) {
      // When Reset Button is Called the statemangnent
      // still has default 0 value and causes end game.
      if (this.state.wrongCounter === 0) {
        this.setState({
          wrongCounter: 5,
        });
      }
      this.generateQuestion();
      this.timeCountdown();
      this.setState({
        gameFlag: 'Reset Game',
        gameStatus: true,
        showHighScore: false,
      });
    } else {
      this.setState({
        gameFlag: 'Reset Game',
        gameStatus: false,
      });
      // this causes 404 not found in netlify
      // window.location.reload(false);
      SetInterval.clear(this.timer, 1000, 'test');
      // console.log('reset game');
      this.gameOver();
      this.generateQuestion();
    }
  }

  // Create Questions
  generateQuestion() {
    if (this.state.wrongCounter < 0) {
      SetInterval.clear('test');
      // console.log(this.state.lastHighestScore);
      this.setState({
        showHighScore: true,
      });
      this.gameOver();
    }

    // Index of Question
    let questionIndex = Math.floor(Math.random() * MapArrData.length);
    let questionSrc = MapArrData[questionIndex][0];
    let questionValue = MapArrData[questionIndex][1];

    // remove the Question to avoid repetition in optionsArray
    MapArrData.splice(questionIndex, 1);

    let randOption1 =
      MapArrData[Math.floor(Math.random() * MapArrData.length)][1];
    let randOption2 =
      MapArrData[Math.floor(Math.random() * MapArrData.length)][1];
    let randOption3 =
      MapArrData[Math.floor(Math.random() * MapArrData.length)][1];

    // pushing all 4 options getting ready for Props
    let optionsArrTemp = [];
    optionsArrTemp.push(questionValue, randOption1, randOption2, randOption3);

    // Shuffling the Array
    optionsArrTemp = this.shuffle(optionsArrTemp);

    // console.log(optionsArrTemp);

    // console.log(questionValue);
    this.setState({
      mapSrc: questionSrc,
      mapValue: questionValue,
      optionsArr: optionsArrTemp,
    });
  }
  // Shuffle the Options Array
  shuffle(array) {
    var currentIndex = array.length,
      temporaryValue,
      randomIndex;
    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }
    return array;
  }

  // Time Countdown

  timeCountdown() {
    // console.log(this.state.gameStatus);
    if (!this.state.gameStatus) {
      // console.log('Timer is on');
      SetInterval.start(this.timer, 1000, 'test');
    } else {
      // console.log(this.state.gameStatus);
      SetInterval.clear(this.timer, 1000, 'test');
      this.gameOver();
    }
  }

  // TIMER
  timer() {
    this.setState((cur) => ({
      timeRemaining: cur.timeRemaining - 1,
      gameStatus: true,
    }));
    if (this.state.timeRemaining === 0 || this.state.wrongCounter === 0) {
      SetInterval.clear('test');
      // console.log(this.state.lastHighestScore);
      this.setState({
        showHighScore: true,
      });
      this.gameOver();
    }
  }

  // GAME OVER
  gameOver() {
    // console.log('Game Over');
    this.setState({
      timeRemaining: 60,
      gameStatus: false,
      wrongCounter: 5,
      // showHighScore: true,
      finalScore: this.state.score,
      score: 0,
    });
    // console.log(this.state.finalScore);
    // console.log(this.state.score);
    SetInterval.clear(this.timer, 1000, 'test');
  }

  // Show ScoreCard
  showScoreCard() {}

  // Increment score for correct answer
  scoreIncrement() {
    this.setState((curState) => ({ score: curState.score + 1 }));
  }

  // Decrement your score for incorrect
  scoreDecrement() {
    this.setState((curState) => ({ wrongCounter: curState.wrongCounter - 1 }));
  }

  render() {
    return (
      <div className='page'>
        {!this.state.showHighScore ? (
          <>
            <Countdown timeRemaining={this.state.timeRemaining} />

            <QuestionContainer
              mapSrc={this.state.mapSrc}
              score={this.state.score}
              wrongCounter={this.state.wrongCounter}
            />
            <OptionsContainer
              mapValue={this.state.mapValue}
              optionsArr={this.state.optionsArr}
              generateQuestion={this.generateQuestion}
              scoreIncrement={this.scoreIncrement}
              scoreDecrement={this.scoreDecrement}
            />
          </>
        ) : (
          <ScoreCard
            finalScore={this.state.finalScore}
            lastHighestScore={this.state.lastHighestScore}
          />
        )}
        <StartBtn start={this.startQuiz} gameFlag={this.state.gameFlag} />
        <div className='copyright'>&#169; Deepankar Bhade 2020</div>
      </div>
    );
  }
}

export default QuizContainer;
